<!-- Custom PrimeNG Toasters
 Create custom templates for PrimeNG toaster messages in here.
 Each one should have a key specified, that's how you choose which one to use when showing a toast message

 This component is used in one place, the app.component.html file so that it is available everywhere.
 It doesn't need to be included anywhere else.
 Toasts are invoked using the message-ui service.

-->

<!-- Default if you don't specify a key-->
<p-toast></p-toast>

<!-- Download Power BI Report -->
<p-toast key="power-bi-report-download" position="top-right" class="opacity-100">
    <ng-template let-message  #headless >
    <div class="flex flex-col items-start {{message.severity}}" (click)="onToastClicked($event)">
        <div class="flex flex-col m-3">
            <div class="flex items-center gap-2">
                <span class="font-bold">{{ message.summary }}</span>
                <span class="grow"></span>
                <!-- <b utton type="button" pripple="" class="p-toast-icon-close p-link p-ripple" (click)="onClose('power-bi-report-download')" ><span class="p-toast-icon-close-icon pi pi-times"></span></button> -->
                <ui-button class="p-toast-icon-close p-link p-ripple" (click)="onClose('power-bi-report-download')" containerClass="close-button"><span class="p-toast-icon-close-icon pi pi-times"></span></ui-button>
            </div>

            <div class="flex align-items-center gap-3 p-toast-icon">
                <div class="spinner-container">
                    <div class="spinner"></div>
                  </div>
                <div class="font-medium text-lg my-4" [innerHTML]="message.detail"></div>
            </div>
        </div>
    </div>
  </ng-template>
</p-toast>

<!-- Download Power BI Report for preview-->
<p-toast key="power-bi-report-download-preview" position="center" class="opacity-100">
    <ng-template let-message  #headless >
    <div class="flex flex-col items-start {{message.severity}}" (click)="onToastClicked($event)">
        <div class="flex flex-col m-3">
            <div class="flex items-center gap-2">
                <span class="font-bold">{{ message.summary }}</span>
                <span class="grow"></span>
                <!-- < button type="button" pripple="" class="p-toast-icon-close p-link p-ripple" (click)="onClose('power-bi-report-download')" ><span class="p-toast-icon-close-icon pi pi-times"></span></button> -->
                 <!-- NOTE: Close button doesn't work -->
                <ui-button class="p-toast-icon-close p-link p-ripple" (click)="onClose('power-bi-report-download')" containerClass="close-button"><span class="p-toast-icon-close-icon pi pi-times"></span></ui-button>
            </div>

            <div class="flex align-items-center gap-3 p-toast-icon">
                <div class="spinner-container">
                    <div class="spinner"></div>
                  </div>
                <div class="font-medium text-lg my-4" [innerHTML]="message.detail"></div>
            </div>
        </div>
    </div>
  </ng-template>
</p-toast>

